import '../css/style.css'
import '../css/animate.css'
import '../css/star.css'
import Header from './Header'
import ScrollToTopButton from './ScrollToTopButton';
import { Link } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';

function About() {
  const [formData, setFormData] = useState({

    name: '',
    email: '',
    willingToUse: false,
  });

  const [isWillingToUseYes, setWillingToUseYes] = useState(false);
  const [isWillingToUseNo, setWillingToUseNo] = useState(false);

  const handleYesChange = () => {
    setFormData({
      ...formData,
      willingToUse: true,
    });
    setWillingToUseYes(!isWillingToUseYes);
    setWillingToUseNo(false);
  };

  const handleNoChange = () => {
    setFormData({
      ...formData,
      willingToUse: false,
    });
    setWillingToUseNo(!isWillingToUseNo);
    setWillingToUseYes(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if name and email fields are empty
    if (!formData.name || !formData.email) {
      // Display SweetAlert error message
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please fill in all fields',
      });
      return;
    }

    console.log('Name:', formData.name);
    console.log('Email:', formData.email);

    try {
      await axios.post('http://localhost:5000/register', {
        name: formData.name,
        email: formData.email,
        willingToUse: formData.willingToUse ? 'Yes' : 'No',
      }, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      // Display success alert using SweetAlert
      Swal.fire({
        icon: 'success',
        title: 'Form Submitted Successfully!',
        text: 'Thank you for joining the waitlist!',
      });

      // Clear input fields after successful submission
      setFormData({
        name: '',
        email: '',
        willingToUse: false,
      });

      // Add any additional logic or redirect here
    } catch (error) {
      if (error.response && error.response.status === 400) {
        // Display error alert for duplicate email
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response.data.error,
        });

        // Clear input fields after displaying error
        setFormData({
          ...formData,
          name:'',
          email: '',
        });
      } else {
        // Display generic error alert
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Error submitting form. Please try again.',
        });
      }
    }
  };
  const [scrollEffect, setScrollEffect] = useState(false);


  useEffect(() => {
    function handleScroll() {
      const scrollPosition = window.scrollY;
      const scrollThreshold = 10; // Adjust as needed
      if (scrollPosition > scrollThreshold) {
        setScrollEffect(true);
      } else {
        setScrollEffect(false);
      }
    }
    // Add scroll event listener when component mounts
    window.addEventListener('scroll', handleScroll);

    // Remove scroll event listener when component unmounts
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []); // Empty dependency array to run only once


  return (
    <>
      <Header />
      {/* ===== Header Start ===== */}
      {/* <include src="./partials/header.html"> */}
      {/* ===== Header End ===== */}
      <main>
        {/* ===== Breadcrumb Section Start ===== */}
        <section className="relative z-10 pt-30 lg:pt-35 xl:pt-40 pb-18">
          {/* bg shapes */}
          <div className="absolute top-25 left-0 w-full flex flex-col gap-3 -z-1 opacity-50">
            <div className="w-full h-[1.24px] footer-bg-gradient" />
            <div className="w-full h-[2.47px] footer-bg-gradient" />
            <div className="w-full h-[3.71px] footer-bg-gradient" />
            <div className="w-full h-[4.99px] footer-bg-gradient" />
            <div className="w-full h-[6.19px] footer-bg-gradient" />
            <div className="w-full h-[7.42px] footer-bg-gradient" />
            <div className="w-full h-[8.66px] footer-bg-gradient" />
            <div className="w-full h-[9.90px] footer-bg-gradient" />
            <div className="w-full h-[13px] footer-bg-gradient" />
          </div>
          <div className="absolute bottom-0 left-0 w-full h-24 bg-gradient-to-b from-dark/0 to-dark -z-1">
          </div>
          <div className="text-center px-4">
            <h1 className="font-bold text-heading-2 text-white mb-5.5">
              About Us
            </h1>
            <ul className="flex items-center justify-center gap-2">
              <li className="font-medium"><a href="/#home">Home</a></li>
              <li className="font-medium">/ About Us</li>
            </ul>
          </div>
        </section>
        {/* ===== Breadcrumb Section End ===== */}
        {/* ===== About Section Start ===== */}
        <section className="overflow-hidden">
          <div className="max-w-[1170px] mx-auto px-4 sm:px-8 xl:px-0 py-20 lg:py-25 relative">
            <div className="absolute bottom-0 left-0 w-full h-[1px] about-divider-gradient" />
            <div className="flex gap-11 flex-wrap justify-between">
              <div className="wow fadeInLeft max-w-[570px] w-full">
                <span className="hero-subtitle-text font-semibold block mb-5">Our Mission</span>
                <p className="text-white font-medium text-heading-7">
                  Intellevo AI is a critical aspect of building robust, scalable,
                  and maintainable software systems. When users input draws
                  regarding seamless software architecture, they likely seek
                  guidance, best practices, or tools to design and implement
                  effective architectures for their projects.
                </p>
                <p className="max-w-[500px] mx-auto mb-9 font-medium md:text-lg">
                </p>
                <Link to="/waitlist" className="hero-button-gradient inline-flex rounded-lg py-3 px-7 text-white font-medium ease-in duration-300 hover:opacity-80">Get Started</Link>
              </div>
              <div className="wow fadeInRight hidden xl:block">
                <img src={require("./images/about/about.svg").default} alt="about" />
              </div>
            </div>
          </div>
        </section>

        {/* <div className="max-w-[1170px] mx-auto px-4 sm:px-8 xl:px-0"> */}
        {/* <div className="wow fadeInUp mb-16 text-center">
            <h2 className="text-white mb-4.5 text-2xl font-extrabold sm:text-4xl xl:text-heading-2">
            </h2>
          </div> */}
        {/* <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-16.5"> */}
        {/* <div className="wow fadeInUp group"> */}
        {/* <div className="mb-6 overflow-hidden rounded-xl">
              </div> */}
        {/* <div className="flex flex-wrap gap-2.5 items-center mb-4.5">


              </div> */}



        {/* <div className="flex items-center gap-4.5 flex-wrap mt-6">
                  <div className="flex items-center gap-2 flex-wrap cursor-pointer ease-in duration-300 hover:text-white">
                    <svg className="fill-current" width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 8.75C7.65625 8.75 5.78125 6.90625 5.78125 4.65625C5.78125 2.40625 7.65625 0.5625 10 0.5625C12.3438 0.5625 14.2188 2.40625 14.2188 4.65625C14.2188 6.90625 12.3438 8.75 10 8.75ZM10 1.96875C8.4375 1.96875 7.1875 3.1875 7.1875 4.65625C7.1875 6.125 8.4375 7.34375 10 7.34375C11.5625 7.34375 12.8125 6.125 12.8125 4.65625C12.8125 3.1875 11.5625 1.96875 10 1.96875Z" fill />
                      <path d="M16.5938 19.4688C16.2188 19.4688 15.875 19.1562 15.875 18.75V17.8438C15.875 14.5938 13.25 11.9688 10 11.9688C6.75 11.9688 4.125 14.5938 4.125 17.8438V18.75C4.125 19.125 3.8125 19.4688 3.40625 19.4688C3 19.4688 2.6875 19.1562 2.6875 18.75V17.8438C2.6875 13.8125 5.96875 10.5625 9.96875 10.5625C13.9688 10.5625 17.25 13.8437 17.25 17.8438V18.75C17.2813 19.125 16.9688 19.4688 16.5938 19.4688Z" fill />
                    </svg>
                    <span className="text-sm font-medium">Co-Founder</span>
                  </div>
                  <div className="flex items-center gap-2 flex-wrap cursor-pointer ease-in duration-300 hover:text-white">
                    <svg className="fill-current" width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M17.5 3.3125H15.875V2.625C15.875 2.25 15.5625 1.90625 15.1562 1.90625C14.75 1.90625 14.4375 2.21875 14.4375 2.625V3.3125H5.53125V2.625C5.53125 2.25 5.21875 1.90625 4.8125 1.90625C4.40625 1.90625 4.09375 2.21875 4.09375 2.625V3.3125H2.5C1.4375 3.3125 0.53125 4.1875 0.53125 5.28125V16.1563C0.53125 17.2188 1.40625 18.125 2.5 18.125H17.5C18.5625 18.125 19.4687 17.25 19.4687 16.1563V5.25C19.4687 4.1875 18.5625 3.3125 17.5 3.3125ZM1.96875 9.125H4.625V12.2188H1.96875V9.125ZM6.03125 9.125H9.3125V12.2188H6.03125V9.125ZM9.3125 13.625V16.6875H6.03125V13.625H9.3125ZM10.7187 13.625H14V16.6875H10.7187V13.625ZM10.7187 12.2188V9.125H14V12.2188H10.7187ZM15.375 9.125H18.0312V12.2188H15.375V9.125ZM2.5 4.71875H4.125V5.375C4.125 5.75 4.4375 6.09375 4.84375 6.09375C5.25 6.09375 5.5625 5.78125 5.5625 5.375V4.71875H14.5V5.375C14.5 5.75 14.8125 6.09375 15.2187 6.09375C15.625 6.09375 15.9375 5.78125 15.9375 5.375V4.71875H17.5C17.8125 4.71875 18.0625 4.96875 18.0625 5.28125V7.71875H1.96875V5.28125C1.96875 4.96875 2.1875 4.71875 2.5 4.71875ZM1.96875 16.125V13.5938H4.625V16.6563H2.5C2.1875 16.6875 1.96875 16.4375 1.96875 16.125ZM17.5 16.6875H15.375V13.625H18.0312V16.1563C18.0625 16.4375 17.8125 16.6875 17.5 16.6875Z" fill />
                    </svg>
                    <span className="text-sm font-medium">AI/ML and JS Software Developer </span>
                  </div>
                </div> */}
        {/* </div> */}
        {/* blog item */}



        {/* </div> */}
        {/* blog item */}

        {/* </div> */}

        {/* ====== Blog Section End */}
        <section id="/#support" className="scroll-mt-17">
          <div className="max-w-[1104px] mx-auto px-4 sm:px-8 xl:px-0">
            <div className="relative z-999 overflow-hidden rounded-[30px] bg-dark pt-25 px-4 sm:px-20 lg:px-27.5">
              {/* grid row */}
              <div className="flex justify-center gap-7.5 absolute left-1/2 -translate-x-1/2 -top-[16%] max-w-[690px] w-full -z-1 opacity-40">
                <div className="max-w-[50px] w-full h-[250px] relative pricing-grid pricing-grid-border bottom-12">
                </div>
                <div className="max-w-[50px] w-full h-[250px] relative pricing-grid pricing-grid-border bottom-7">
                </div>
                <div className="max-w-[50px] w-full h-[250px] relative pricing-grid pricing-grid-border bottom-3">
                </div>
                <div className="max-w-[50px] w-full h-[250px] relative pricing-grid pricing-grid-border">
                </div>
                <div className="max-w-[50px] w-full h-[250px] relative pricing-grid pricing-grid-border">
                </div>
                <div className="max-w-[50px] w-full h-[250px] relative pricing-grid pricing-grid-border">
                </div>
                <div className="max-w-[50px] w-full h-[250px] relative pricing-grid pricing-grid-border bottom-2">
                </div>
                <div className="max-w-[50px] w-full h-[250px] relative pricing-grid pricing-grid-border bottom-5">
                </div>
                <div className="max-w-[50px] w-full h-[250px] relative pricing-grid pricing-grid-border bottom-8">
                </div>
              </div>
              {/* stars */}
              <div className="max-w-[482px] w-full h-60 overflow-hidden absolute -z-1 -top-30 left-1/2 -translate-x-1/2">
                <div className="stars" />
                <div className="stars2" />
              </div>
              {/* bg shapes */}
              <div className="absolute -z-10 pointer-events-none inset-0 overflow-hidden">
                <span className="absolute left-1/2 top-0 -translate-x-1/2 -z-1">
                  <img src={require('../images/blur/blur-19.svg').default} alt="blur" className="max-w-none" />
                </span>
                <span className="absolute left-1/2 top-0 -translate-x-1/2 -z-1">
                  <img src={require('../images/blur/blur-20.svg').default} alt="blur" className="max-w-none" />
                </span>
                <span className="absolute left-1/2 top-0 -translate-x-1/2 -z-1">
                  <img src={require('../images/blur/blur-21.svg').default} alt="blur" className="max-w-none" />
                </span>
              </div>
              {/* section title */}
              <div className="wow fadeInUp mb-16 text-center relative z-999">
                <span className="hero-subtitle-gradient relative mb-4 font-medium text-sm inline-flex items-center gap-2 py-2 px-4.5 rounded-full">
                  <img src={require('../images/hero/icon-title.svg').default} alt="icon" />
                  <span className="text-white">Need any assistance? </span>
                </span>
                <h2 className="text-white mb-4.5 text-2xl font-bold sm:text-4xl xl:text-heading-2">
                  Contact us
                </h2>
                <p className="max-w-[714px] mx-auto font-medium text-white">
                  Require assistance or have inquiries? Feel free to send us a message, and we'll get in touch with you via email.
                </p>
              </div>
              <div className="form-box-gradient relative overflow-hidden rounded-[25px] bg-dark p-6 sm:p-8 xl:p-15">
                <form className="relative z-10" onSubmit={handleSubmit}>
                  <div className="-mx-4 xl:-mx-10 flex flex-wrap">
                    <div className="w-full px-4 xl:px-5 md:w-1/2">
                      <div className="mb-9.5">
                        <label htmlFor="name" className="text-white mb-2.5 block font-medium">
                          Name
                        </label>
                        <input
                          id="name"
                          type="text"
                          name="name"
                          placeholder="Enter your name"
                          value={formData.name}
                          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                          className="rounded-lg border border-white/[0.12] bg-white/[0.05] focus:border-purple w-full py-3 px-6 outline-none" />
                      </div>
                    </div>
                    <div className="w-full px-4 xl:px-5 md:w-1/2">
                      <div className="mb-9.5">
                        <label htmlFor="email" className="text-white mb-2.5 block font-medium">
                          Email
                        </label>
                        <input id="email"
                          type="email"
                          name="email"
                          value={formData.email}
                          placeholder="Enter your email"
                          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                          className="rounded-lg border border-white/[0.12] bg-white/[0.05] focus:border-purple w-full py-3 px-6 outline-none" />
                      </div>
                    </div>
                    <div className="w-full px-4 xl:px-5">
                      <div className="mb-10">
                      </div>
                    </div>
                    <div className="w-full px-4 xl:px-5">
                      <div className="text-center">
                        <button href="#" className="hero-button-gradient inline-flex rounded-lg py-3 px-7 text-white font-medium ease-in duration-300 hover:opacity-80">
                          Join Now
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
        {/* ====== CTA Section Start */}
        <section>
          <div className="max-w-[1170px] mx-auto px-4 sm:px-8 xl:px-0">
            <div className="cta-box-gradient bg-dark rounded-[30px] relative overflow-hidden px-4 py-20 lg:py-25 z-999">
              {/* bg shapes */}
              <span className="absolute bottom-0 left-0 -z-1"><img src={require('../images/cta/grid.svg').default} alt="grid" /></span>
              <div className="absolute -z-10 pointer-events-none inset-0 overflow-hidden">
                <span className="absolute left-1/2 bottom-0 -translate-x-1/2 -z-1">
                  <img src={require('../images/blur/blur-22.svg').default} alt="blur" className="max-w-none" />
                </span>
                <span className="absolute left-1/2 bottom-0 -translate-x-1/2 -z-1">
                  <img src={require('../images/blur/blur-23.svg').default} alt="blur" className="max-w-none" />
                </span>
                <span className="absolute left-1/2 bottom-0 -translate-x-1/2 -z-1">
                  <img src={require('../images/blur/blur-24.svg').default} alt="blur" className="max-w-none" />
                </span>
              </div>
              {/* stars */}
              <div className="max-w-[482px] w-full h-60 overflow-hidden absolute -z-1 -bottom-25 left-1/2 -translate-x-1/2">
                <div className="stars" />
                <div className="stars2" />
              </div>
              <div className="wow fadeInUp text-center">
                <span className="hero-subtitle-gradient relative mb-4 font-medium text-sm inline-flex items-center gap-2 py-2 px-4.5 rounded-full">
                  <img src={require('../images/hero/icon-title.svg').default} alt="icon" />
                  <span className="text-white">
                  <Link to="/waitlist">Join Us</Link>
                  </span>
                </span>
                <h2 className="text-white mb-4.5 text-2xl font-bold sm:text-4xl xl:text-heading-2">
                  Capture boundless opportunities now! <span class='blinking-star'></span>
                </h2>
                <p className="max-w-[714px] mx-auto font-medium mb-9 text-white">
                  Step into the Intellevo world as every second counts in shaping your success.                </p>
                <a href="#" className="hero-button-gradient inline-flex rounded-lg py-3 px-7 text-white font-medium ease-in duration-300 hover:opacity-80">
                  <Link to="/waitlist">Join Intellevo</Link>

                </a>
              </div>
            </div>
          </div>
        </section>
        {/* ====== CTA Section End */}
        {/* ====== Newsletter Section Start */}
        {/* <section className="pt-17.5 sm:pt-22.5 xl:pt-27.5 pb-11">
          <div className="max-w-[1170px] mx-auto px-4 sm:px-8 xl:px-0">
            <div className="flex flex-wrap items-center justify-between gap-10">
              <div className="max-w-[352px] w-full">
                <h3 className="font-semibold text-heading-5 text-white mb-2">
                  News &amp; Update
                </h3>
                <p className="font-medium">
                  Keep up to date with everything about our tool
                </p>
              </div>
              <div className="max-w-[534px] w-full">
                <form>
                  <div className="flex items-center gap-4">
                    <div className="max-w-[395px] w-full">
                      <input id="email" type="email" name="email" placeholder="Enter your email" className="rounded-lg border border-white/[0.12] bg-white/[0.05] focus:border-purple w-full py-3 px-6 outline-none" />
                    </div>
                    <a href="/#" className="button-border-gradient relative rounded-lg text-white text-sm flex items-center gap-1.5 py-3.5 px-7 shadow-button hover:button-gradient-hover hover:shadow-none">
                      Subscribe
                    </a>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section> */}
        {/* ====== Newsletter Section End */}
      </main>
      {/* ===== Footer Start ===== */}
      {/* <include src="./partials/footer.html"> */}

      {/* ===== Footer End ===== */}
      {/* ====== Back To Top Start ===== */}

      {/* ====== Back To Top End ===== */}
      <ScrollToTopButton />

    </>

  )
}

export default About;
